'use strict';
define('app',[
        'element-queries',
        'elements/navigation__map',
        'elements/navigation__inpage',
        'elements/accordion',
        'elements/trip__sidebar-sticky',
        'elements/sly',
        'elements/object-fit',
        'elements/disable-scroll',
        'elements/disable-scroll-zoom',
        'elements/colorbox',
        'elements/inquiry',
        'elements/link-select',
        'elements/map',
        'elements/sidebar--blog',
        'elements/shop',
        'elements/print-lazy-images',
    ],
    function () {
});

